export default "__VITE_ASSET__Bje1ynkW__"